import snowplow from '@core/Util/snowplow'

const EVENT_CATEGORY = 'JourneyBuilder';

export default {
    //Overwrite default trackStructuredEvent
    trackStructuredEvent: (action, label, property, value) => {
        snowplow.trackStructuredEvent(EVENT_CATEGORY, action, label, property, value);
    }
}